<div class="container">
  <img
    src="./assets/xmart-icon.ico"
    alt="xmart-logo"
    onerror="this.src='../assets/xmart-icon.ico'"
    width="20"
    height="20"
    style="padding-right: 5px"
  />
  <p
    class="link"
    style="text-decoration: underline"
    size="body-1"
    (click)="onClickOpenLinkToSummary()"
    (keyup.enter)="onClickOpenLinkToSummary()"
    tabindex=""
  >
    XMART Summary
  </p>
</div>
